import {HttpClient} from "../../service/httpClient/HttpClient";

export class GameRegistrationService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getGameRegistrationList(gamePeriodId, page, size, fullName, phoneNumber, gender, status) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `game-periods/${gamePeriodId}/registrations`,
                {
                    page,
                    size,
                    "full-name": fullName && fullName.length > 0 ? fullName : null,
                    "phone-number": phoneNumber && phoneNumber.length > 0 ? phoneNumber : null,
                    "gender": gender && gender !== "ALL" && gender.length > 0 ? gender : null,
                    "status": status && status !== "ALL" && status.length > 0 ? status : null
                }
            ).then(resolve).catch(reject)
        })
    }

    getGameRegistrantBasicInformation(registrantId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `game-registrations/${registrantId}/owner-information`,
                {}
            ).then(resolve).catch(reject)
        })
    }

    getGameRegistrantAdditionalInformation(registrantId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `game-registrations/${registrantId}/information`
            ).then(resolve).catch(reject)
        })
    }

    getGamerStatus(registrantId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `game-registrations/${registrantId}/status`
            ).then(resolve).catch(reject)
        })
    }

    approveGamerRegistration(registrantId) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `game-registrations/${registrantId}/approve`,
            ).then(resolve).catch(reject)
        })
    }

    rejectGamerRegistration(registrantId, status, reason) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `game-registrations/${registrantId}/rejected`,
                {},
                {
                    reason
                }
            ).then(resolve).catch(reject)
        })
    }
}